import React from "react";

import { useCommunityAuth } from "../auth/CommunityAuthContext.jsx";
import { useSession } from "../context/SessionContext.jsx";

/** Follow / Following toggle. Renders nothing on your own profile. */
const FollowButton = ({ uid, name, small = false, block = false }) => {
  const { requireAuth } = useCommunityAuth();
  const { currentUid, isFollowing, toggleFollow } = useSession();
  if (uid === currentUid) return null;

  const on = isFollowing(uid);
  const classes = ["btn", on ? "btn--ghost" : "btn--primary"];
  if (small) classes.push("btn--small");
  if (block) classes.push("btn--block");

  return (
    <button
      type="button"
      className={classes.join(" ")}
      aria-pressed={on}
      onClick={() => (
        requireAuth(
          () => toggleFollow(uid),
          { reason: `Sign up to follow ${name || "this member"}.` },
        )
      )}>
      {on && (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M5 12l5 5 9-10" />
        </svg>
      )}
      {on ? "Following" : name ? `Follow ${name}` : "Follow"}
    </button>
  );
};

export default FollowButton;
